module.exports = __webpack_public_path__ + "static/heroBg-facf0fd9db8319f1814cd629c18e73ab.jpg";